import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path
      d="M10.2068 4.47832C9.57788 3.16389 8.64111 1.96607 7.43429 1.1376C7.16703 0.95412 6.83274 0.954134 6.56549 1.13764C5.35873 1.96615 4.42196 3.16392 3.79297 4.47832"
      stroke="#B3B3B3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M7 1.44141V10.5575" stroke="#B3B3B3" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M1 7.85547V8.9037C1 9.45967 1.1945 9.99282 1.54073 10.386C1.88695 10.779 2.35652 10.9999 2.84615 10.9999H11.1539C11.6435 10.9999 12.1131 10.779 12.4593 10.386C12.8055 9.99282 13 9.45967 13 8.9037V7.85547"
      stroke="#B3B3B3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const MinUploadIcon = memo(ForwardRef);
export default MinUploadIcon;
